// @ts-check
// apolo/src/lib/brandedIds.js — P5-T01 (software-to-9).
//
// Branded (opaque) ID types: a plain `string` carries no information about WHICH id
// it is, so a userId silently flows into a sessionId slot. A brand (`string & {
// __brand }`) makes those illegal states unrepresentable at the type level — under
// the scoped checkJs (apolo/tsconfig.contracts.json), passing the wrong id is a tsc
// error. At runtime they ARE strings (zero cost); the brand exists only in the type
// system. Construct via the `as*` helpers at a trust boundary (a fresh id, a DB row).
//
// Domain Modeling Made Functional — make illegal states unrepresentable.

/** @typedef {string & { readonly __brand: 'SessionId' }} SessionId */
/** @typedef {string & { readonly __brand: 'UserId' }} UserId */
/** @typedef {string & { readonly __brand: 'RunId' }} RunId */
/** @typedef {string & { readonly __brand: 'TurnId' }} TurnId */

/** @param {string} s @returns {SessionId} */
export const asSessionId = (s) => /** @type {SessionId} */ (s);
/** @param {string} s @returns {UserId} */
export const asUserId = (s) => /** @type {UserId} */ (s);
/** @param {string} s @returns {RunId} */
export const asRunId = (s) => /** @type {RunId} */ (s);
/** @param {string} s @returns {TurnId} */
export const asTurnId = (s) => /** @type {TurnId} */ (s);

/**
 * Example seam consumer: it accepts ONLY a SessionId. Calling it with a UserId is a
 * tsc error (UserId not assignable to SessionId) — that is the teeth.
 * @param {SessionId} id
 * @returns {string}
 */
export function sessionEventsPath(id) {
  return `/api/code/sessions/${id}/events`;
}

// Compile-time self-check: the CORRECT id type-checks. Swap asSessionId→asUserId
// below and `npm run tsc:fe-contract` fails (the seam rejects the wrong id).
export const BRANDED_SELFCHECK = sessionEventsPath(asSessionId('s1'));
